module.exports = __webpack_public_path__ + "img/065.46aaf782.jpeg";